module.exports = __webpack_public_path__ + "img/logo.26629652.svg";